import React, { useState, useEffect } from 'react';
import { Monitor, X } from 'lucide-react';
import { Button } from './ui/button';

const SmallScreenWarning = () => {
    const [show, setShow] = useState(false);
    const [dismissed, setDismissed] = useState(false);

    useEffect(() => {
        const checkScreenSize = () => {
            const isSmallScreen = window.innerWidth < 1024;
            const wasDismissed = sessionStorage.getItem('smallScreenDismissed') === 'true';
            setShow(isSmallScreen && !wasDismissed && !dismissed);
        };

        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);
        return () => window.removeEventListener('resize', checkScreenSize);
    }, [dismissed]);

    const handleDismiss = () => {
        setDismissed(true);
        setShow(false);
        sessionStorage.setItem('smallScreenDismissed', 'true');
    };

    if (!show) return null;

    return (
        <div className="fixed inset-0 bg-black/70 z-[100] flex items-center justify-center p-4" data-testid="small-screen-warning">
            <div className="bg-white rounded-lg shadow-2xl max-w-md w-full overflow-hidden">
                {/* Header */}
                <div className="bg-[#0B3D91] p-6 text-white text-center">
                    <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                        <Monitor className="w-8 h-8" />
                    </div>
                    <h2 className="font-['Barlow_Condensed'] text-2xl font-bold uppercase tracking-wide">
                        Pantalla Pequeña Detectada
                    </h2>
                </div>

                {/* Content */}
                <div className="p-6 text-center">
                    <p className="text-slate-600 mb-4">
                        <strong>Segumax Planner</strong> está optimizado para pantallas de escritorio y resoluciones mayores a 1024px.
                    </p>
                    <p className="text-slate-500 text-sm mb-6">
                        En dispositivos móviles o pantallas pequeñas, algunas funciones pueden no visualizarse correctamente y la experiencia de uso puede verse limitada.
                    </p>
                    
                    <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
                        <p className="text-amber-800 text-sm">
                            <strong>Recomendación:</strong> Para una mejor experiencia, accedé desde una computadora de escritorio o laptop.
                        </p>
                    </div>

                    <Button 
                        onClick={handleDismiss}
                        className="w-full bg-[#FF6B00] hover:bg-[#e65000] text-white font-semibold py-3"
                        data-testid="dismiss-warning-btn"
                    >
                        Entendido, continuar de todos modos
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default SmallScreenWarning;
